module.exports = __webpack_public_path__ + "static/mobilitat1-a220c055eefc027580796990240cde13.png";